import {withKnownRoute} from '../../lib/routes';
import {FeatsPage} from './feats-page';

export default withKnownRoute(FeatsPage);
